'use client';

import { useEffect, useRef, useState } from 'react';

import { PauseIcon, PlayIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';

export function AudioPlayer({ src, currentAudio, setCurrentAudio }) {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  // Pause if another audio is playing
  useEffect(() => {
    if (currentAudio !== src && isPlaying) {
      audioRef.current?.pause();
      setIsPlaying(false);
    }
  }, [currentAudio, src, isPlaying]);

  const togglePlay = (e) => {
    e.stopPropagation();
    const audio = audioRef.current;
    if (!audio) return;

    if (isPlaying) {
      audio.pause();
      setIsPlaying(false);
      setCurrentAudio(null);
    } else {
      setCurrentAudio(src);
      audio.play();
      setIsPlaying(true);
    }
  };

  return (
    <div className="flex items-center">
      <audio ref={audioRef} src={src} preload="metadata" />
      <Button size="icon" variant="ghost" onClick={togglePlay}>
        {isPlaying ? <PauseIcon className="size-4" /> : <PlayIcon className="size-4" />}
      </Button>
    </div>
  );
}
